import {
  ADRESSE,
  CENTRE_COMMERCIAL,
  LIGNE_BUS, PARKING,
  CLIENT,
} from '@/configuration/gabed/emplacement/emplacementConf';
import genererEmplacementAdresse
  from '@/services/gabed/emplacement/adresse/genererEmplacementAdresse';
import genererEmplacementCentreCommercial
  from '@/services/gabed/emplacement/centreCommercial/genererEmplacementCentreCommercial';
import genererEmplacementClient from '@/services/gabed/emplacement/client/genererEmplacementClient';
import fillEmplacementWithData
  from '@/services/import/patrimoine/generation/emplacement/fillEmplacementWithData';

export default function generationEmplacement(emplacementReference, infosApiRef) {
  let emplacement = null;
  switch (emplacementReference.type) {
    case ADRESSE:
      emplacement = genererEmplacementAdresse();
      emplacement.type = ADRESSE;
      break;
    case CENTRE_COMMERCIAL:
      emplacement = genererEmplacementCentreCommercial();
      emplacement.type = CENTRE_COMMERCIAL;
      break;
    case LIGNE_BUS:
      emplacement = genererEmplacementCentreCommercial();
      emplacement.type = LIGNE_BUS;
      break;
    case PARKING:
      emplacement = genererEmplacementCentreCommercial();
      emplacement.type = PARKING;
      break;
    case CLIENT:
      emplacement = genererEmplacementClient();
      emplacement.type = CLIENT;
      emplacement.clientId = infosApiRef.clients
        .find(c => c.referenceExterne === emplacementReference.codeClient)?.id || null;
      break;
    default:
      break;
  }
  emplacement.dispositifs = [];
  return fillEmplacementWithData(emplacementReference, emplacement);
}
